<template>
    <div class="bg-uploader">
        <button type="button" @click="triggerInput">Seleccionar imagen</button>
        <input type="file" ref="fileInput" accept="image/jpeg, image/jpg, image/png" @change="handleFileChange"
            style="display: none" />
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </div>
</template>
<script>
export default {
    name: "BgUploader",
    props: {
        eventData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            errorMessage: "",
            eventSelected: this.eventData,
        };
    },
    methods: {
        triggerInput() {
            this.$refs.fileInput.click();
        },
        handleFileChange(e) {
            const file = e.target.files[0];
            this.errorMessage = "";
            if (!file) return;
            // Validar tipo de archivo
            const validTypes = ["image/jpeg", "image/jpg", "image/png"];
            if (!validTypes.includes(file.type)) {
                this.errorMessage = "Solo se permiten imágenes JPG o PNG.";
                return;
            }
            // Leer imagen para validar dimensiones
            const img = new Image();
            const url = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                URL.revokeObjectURL(url);
                // Validación de proporción y tamaño mínimo
                const aspectRatio = width / height;
                const validAspect = Math.abs(aspectRatio - (2 / 3)) < 0.01; // margen de error pequeño
                const minWidth = 1200;
                const minHeight = 1800;
                if (!validAspect) {
                    this.errorMessage =
                        "La imagen debe tener proporción 2:3 (ej. 2400x3600 o 1200x1800).";
                    return;
                }
                if (width < minWidth || height < minHeight) {
                    this.errorMessage =
                        "La imagen es demasiado pequeña. Debe ser al menos 1200x1800 píxeles.";
                    return;
                }
                // Si todo es válido, emitir el archivo para subirlo luego
                this.$emit("image-selected", file);
            };
            img.onerror = () => {
                this.errorMessage = "El archivo seleccionado no es una imagen válida.";
            };
            img.src = url;
        },
    },
};
</script>
<style scoped>
.bg-uploader {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
}
button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 14px;
    border-radius: 6px;
    cursor: pointer;
}
button:hover {
    background-color: #0056b3;
}
.error {
    color: #d9534f;
    font-size: 0.9rem;
}
</style>
